<template>
    <div
        class="banner d-flex flex-row nowrap align-items-center bg-green-100"
        :style="styles"
    >
        <div class="svg-slot me-2">
            <slot name="svg" />
        </div>
        <div class="text-slot w-100">
            <slot name="text" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, defineProps } from 'vue'


interface Props {
    background?: string
}

// props
const props = defineProps<Props>()

// computed
const styles = computed(() => {
    return {
        background: props.background,
    }
})
</script>

<style  scoped>
.banner {
    border-radius: 8px;
    padding: 12px;
}
</style>